module.exports = __webpack_public_path__ + "static/media/plumas.b2fd08b4.png";